"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const taskStore_1 = require("../../../taskStore");
const fillerTrialIds = ['ToM-intro', 'ToM-transition'];
const getLayoutConfig = (stimulus, translations, mediaAssets) => {
    const { answer, distractors, trialType } = stimulus;
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.stimText = {
        value: (0, helpers_1.convertItemToString)(stimulus.item),
        displayValue: undefined,
    };
    defaultConfig.classOverrides.promptClassList = ['lev-row-container', 'instruction-small'];
    if (!defaultConfig.isInstructionTrial) {
        const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
        const prepChoices = (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, stimulus.randomize, trialType);
        defaultConfig.isStaggered = true;
        defaultConfig.isImageButtonResponse = true;
        defaultConfig.response = {
            target: prepChoices.target,
            displayValues: prepChoices.choices,
            values: prepChoices.originalChoices,
            targetIndex: prepChoices.correctResponseIdx,
        };
    }
    else {
        defaultConfig.classOverrides.buttonClassList = ['primary'];
        defaultConfig.disableOkButton = true;
    }
    defaultConfig.blockedTrials = (0, taskStore_1.taskStore)().version === 2 && !fillerTrialIds.includes(stimulus.itemId);
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
